import React, {useState, useEffect} from 'react'
import { Redirect } from 'react-router-dom'
import { config } from '../server'
import '../styles/global.css'
import '../styles/newset.css'
const address = config.url.API_URL

const SetTitle = () => {
    const [studyTitle, setStudyTitle] = useState('')
    const [changeDir, setChangeDir] = useState(false)
    const [doesExist, setDoesExist] = useState([])

    useEffect(() => {
        let isSubscribed = true;
    if(isSubscribed){
        fetch(address + '/api/getSets').then(res => res.json()).then(data => {
        const data2 = data.allDocs
        let vals = []
        for(let i = 0; i < data.allDocs.length; i++) {
            vals.push(data2[i].studyTitle)
    }
        const unique = new Set(vals)
        const newUnique = [...unique]
        setDoesExist(newUnique)
    });
}
    return () => isSubscribed = false
    }, []);
    const handleForm = (e) => {
        e.preventDefault()
        for(let exists of doesExist){
            if(studyTitle === exists){
                alert('This study set name already exists!')
                return;
            }
        }
        if(studyTitle.length !== 0){
            setChangeDir(true)
        } else {
            alert("Please fill out the form properly")
        }
    }

    

    return (
        <div>

            <div className="heroContainer">
                <h1>New Study Set</h1>
                <p>Create a new study set for yourself and other users.</p>
            </div>

            {changeDir &&(<Redirect from="/create" to={{
            pathname: '/addContent',
            state: { studyTitle: studyTitle }
            }}/>    )}

            <div className="formContainer">
                <h2>Set Title</h2>
                <form onSubmit={handleForm}>    
                    <input placeholder="AP Physics" className="blueTextInput fullWidthTextInput" name="numTopics" id="numTopics" type="text" onChange={e => setStudyTitle(e.target.value)} />
                    <input type="submit" value="Next Step" className="tealBtn"/>
                </form>
            </div>
            
        </div>
    )
}

export default SetTitle